<template>
  <div
    v-if="reseted"
    id="rmpPlayer"
    class="video-player"
  />
</template>

<script>
  // export
  export default {
    name: 'VideoPlayer',
    props: {
      src: {
        type: String,
        default: '',
        required: true,
      },
    },
    data () {
      return {
        player: null,
        playerSrc: {
          dash: ' ',
        },
        reseted: true,
        customEventName: '',
      }
    },
    watch: {
      src (newVal, oldVal) {
        if (newVal) {
          if (this.player) {
            this.player.stop()
            this.player.destroy()
          }
          this.initialize(newVal)
        }
      },
    },
    mounted () {
      if (!this.player) {
        // this.initialize()
      }
    },
    beforeDestroy () {
      if (this.player) {
        this.player.stop()
        this.player.destroy()
      }
    },
    methods: {
      initialize (url) {
        if (url) {
          this.playerSrc.dash = url
        }
        const settings = {
          licenseKey: 'amxtbHpteGphbEAxNTYxMTI5',
          src: this.playerSrc,
          // sLiveDvr: true,
          // detectAutoplayCapabilities: true,
          autoplay: true,
          skin: 's2',
          contentMetadata: {},
          width: 948,
          height: 404,
        }

        // emit event
        const emitPlayerState = (event, value) => {
          if (event) {
            this.$emit(event, this.player)
          }
          if (value) {
            this.$emit(this.customEventName, { [event]: value })
          }
        }

        // eslint-disable-next-line no-undef
        this.player = new RadiantMP('rmpPlayer')
        this.player.init(settings)

        const rmpContainer = document.getElementById('rmpPlayer')

        const self = this
        rmpContainer.addEventListener('warning', function () {
          if (self.player) {
            const d = self.player.getErrorData()
            emitPlayerState('warning', d.event)
            console.log('warning', d)
            if (d.event && d.event.details === 'bufferStalledError') {
              // setNewLink();
            }
          }
        })

        rmpContainer.addEventListener('ready', function () {
          emitPlayerState('ready', true)
        })
      },
    },
  }
</script>

<style>
</style>
